import { initLoading, showHideLoading } from "../../components/loading/loading";
import { findItem, getQueryStringParams } from "../../utils/common-function";
export function browserParamsHandler(data) {
    let browserInputObject = getQueryStringParams(data);
    return browserInputObject;
}
export function loadingHandler(parent) {
    initLoading(parent);
}
export function Loading(disabled) {
    showHideLoading(disabled);
}
export function findItemInList(array, column, id) {
    return findItem(array, column, id);
}
